<ng-container
  *ngIf="
    (!!quantityControl.value ||
      !!quantity() ||
      inventoryTotals() ||
      hasTrueDemandInventory()) &&
      !isLocked() &&
      !readonly &&
      !sizeRunsCell;
    else noInvTemplate
  "
>
  @if((checkInventoryForBackOrder$ | async) && backOrdersOnly() &&
  (backOrderNotEnabled$ | async)) {
  <ng-container [ngTemplateOutlet]="noInvTemplate"></ng-container>
  } @else {
  <div
    class="text-center absolute-center behind"
    [class.d-none]="cellInFocus || quantityControl.value !== ''"
  >
    <ng-template [ngTemplateOutlet]="placeholderTemplate"></ng-template>
  </div>

  @if (hasTrueDemandInventory() && hasConsumedTrueDemand()) {
  <div class="absolute-top px-1 font-size-sm" [class.d-none]="cellInFocus">
    <span class="text-success" [atxTooltip]="availableInventoryTooltipLabel">{{
      splitQuantityToNormalAndTrueDemand()[0]
    }}</span>
    <span class="text-danger" [atxTooltip]="trueDemandInventoryTooltipLabel">{{
      splitQuantityToNormalAndTrueDemand()[1]
    }}</span>
  </div>
  }

  <!-- Note,
         min(
           max(
             inventory.totals, - possible value
              quantityControl.value, - current value
               quantity - default value on component initialization
       " -->
  <input
    *ngrxLet="maxUnlimitedQuantityOrder$; let maxUnlimitedQuantityOrder"
    navCell
    #input
    class="size-quantity inset-cover"
    [class.input-text-has-value]="quantityControl.value > 0"
    [ngClass]="cellInputClass$ | async"
    min="0"
    (click)="input.select()"
    atxMax
    [max]="
      skipInventoryCheck() || hasTrueDemandInventory()
        ? maxUnlimitedQuantityOrder
        : min(
            max(inventory().totals, currentCellValue),
            max(maxUnlimitedQuantityOrder, inBasketQuantity)
          )
    "
    type="number"
    atxNumberInput
    [formControl]="quantityControl"
    (keydown.-)="$event.preventDefault()"
    (blur)="cellInFocus = false; blur()"
    (paste)="onPaste($event)"
    (focus)="cellInFocus = true; cellClicked.emit(); input.click()"
    (keyup.enter)="cellKeyupEnter.emit(); input.blur()"
    data-e2e="cell"
    inputmode="numeric"
    autocomplete="off"
  />

  <span
    *ngIf="showInventoryPlaceholderOnFocus"
    data-e2e="inventory-placeholder-value"
    class="input-active-placeholder position-absolute small"
    [ngClass]="cellSpanClass$ | async"
    [class.d-none]="!cellInFocus"
  >
    <ng-template [ngTemplateOutlet]="placeholderTemplate"></ng-template>
  </span>

  <ng-template
    *ngIf="backOrdersOnly()"
    [ngTemplateOutlet]="hasOnlyBackOrder"
  ></ng-template>
  }
</ng-container>

<ng-template #noInvTemplate>
  <ng-container *ngIf="!sizeRunsCell; else readOnlyTemplate">
    <span
      data-e2e="quantity-cell"
      class="plain-quantity-cell"
      *ngIf="quantity(); else emptyCellTemplate"
    >
      {{ quantity() }}
    </span>
  </ng-container>
  <ng-template #readOnlyTemplate>
    <span
      class="font-weight-bold text-body plain-quantity-cell readonly-value"
      *ngIf="quantity(); else placeholderTemplate"
    >
      {{ quantity() }}
    </span>
  </ng-template>
</ng-template>

<ng-template #emptyCellTemplate>
  <!-- button is used, so grid-navigation.directive won't lose focus from grid after navigation to disabled cell -->
  <button
    navCell
    navDisabled
    (navigationBlur)="cellInFocus = false"
    (navigationSelect)="cellInFocus = true; cellClicked.emit()"
    class="w-50 h-100 center disabled-cell"
    i18n="Size Grid|Empty cell character@@emptyCellCharacter"
  >
    -
  </button>
</ng-template>

<ng-template #placeholderTemplate>
  <!-- hidePlaceholder = true -->
  @if (showBackOrderFactory()) {
  <span [class.readonly-value]="sizeRunsCell">
    <fa-icon
      class="w-100 factory-icon"
      [icon]="['fas', 'industry-windows']"
    ></fa-icon>
  </span>
  } @else {
  <ng-container *ngTemplateOutlet="notBackOrders"></ng-container>
  }

  <ng-template #notBackOrders>
    <ng-container *ngrxLet="displayedCellTotals$ as total">
      <ng-container *ngIf="total === infinity">
        <fa-icon
          class="w-100 sign-icon"
          [class.readonly-value]="sizeRunsCell"
          [icon]="['fas', 'infinity']"
        ></fa-icon>
      </ng-container>

      <ng-container *ngIf="total !== infinity">
        <span [class.readonly-value]="sizeRunsCell">{{ total }}</span>
      </ng-container>
    </ng-container>
  </ng-template>
</ng-template>

<ng-template #hasOnlyBackOrder>
  <div class="backorder-indicator"></div>
</ng-template>

<ng-content></ng-content>
